//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apiConst from '../service/api/api-const'
    export default{
        name:'christmas_form_six_detail',
        data(){
            return{
                get_host:host.host,
                host:apiConst.host,
                form:{
                    // prove:[],
                    // intermediate_nurse_sign:'',
                    // senior_nurse:''
                },
                
                showSignature:true,
                showCSignature:true,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            goEdit(){
                this.$router.push({
                    path:'christmas_form_six_edit', 
                    query:{
                        id:this.$route.query.id,
                        tabVal: this.$route.query.tabVal,
                    }
                })
            },
            saveCName(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.intermediate_nurse_sign = encodeURI(png)
                this.showCSignature = true
            },
            editCName(){
                this.showCSignature = false
            },
            clearCName(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.intermediate_nurse_sign = ''
            },
            saveName(){
                let signature ='signature2'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.senior_nurse = encodeURI(png)
                this.showSignature = true
            },
            editName(){
                this.showSignature = false
            },
            clearName(){
                let signature ='signature2'
                let refs = this.$refs[signature].clear()
                this.form.senior_nurse = ''
            },
            submitForm(){
                let params={
                    token:this.$cookie.get('token'),
                    number_id:this.$cookie.get('id'),
                    maternal_info_id:this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    intermediate_nurse_sign:this.form.intermediate_nurse_sign,
                    senior_nurse:this.form.senior_nurse
                }
                let prove=this.form.prove
                Api.otherFormApi.updateMaternalLeaveProveRecor(params,prove).then ( res => {
                    console.info(res)
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            },
            //图片上传
            fileImage(e){
                var file = e.target.files[0];
                var that=this;
                lrz(file)
                .then(function (rst) {
                    // 处理成功会执行
                    if(that.form.prove.length == 6){
                        that.$vux.toast.show({
                            type: 'cancel',
                            text: '最多上传6张图片',
                        })
                        return
                    }
                    console.info("rst",rst)
                    that.form.prove.push(rst)
                    console.info(that.form.prove)
                })
                .catch(function (err) {
                    console.info(err)
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '网络错误',
                    })
                    // 处理失败会执行
                })
            },
            //删除图片
            delImg(index,id){
                console.info(index,id)
               
            },
            //转base64
            convertBase64UrlToBlob(urlData) {
                var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
                //处理异常,将ascii码小于0的转换为大于0
                var ab = new ArrayBuffer(bytes.length);
                var ia = new Uint8Array(ab);
                for(var i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                return new Blob([ab], {
                    type: 'image/png'
                });
            }
        },
        created(){
           let params={
                token:this.$cookie.get('token'),
                number_id:this.$cookie.get('id'),
                maternal_info_id:this.$route.query.id,
                store_id:this.$cookie.get('store_id'),
           }
           Api.otherFormApi.getMaternalLeaveProveRecord(params).then ( res => {
               console.info("出院证明详情",res)
               if(res.errcode==200){
                   this.form=res.data
                   this.form.intermediate_nurse_sign=res.data.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? res.data.intermediate_nurse_sign : this.get_host+res.data.intermediate_nurse_sign
                   this.form.senior_nurse=res.data.senior_nurse.indexOf(this.get_host) != -1 ? res.data.senior_nurse : this.get_host+res.data.senior_nurse
               }
            })
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_six_detail.vue